import React from "react";

const MAP = {
  verification: {
    verified: ["Verified", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    under_review: ["Under Review", "bg-amber-50 text-amber-700 border-amber-200"],
    information_required: ["Information Required", "bg-orange-50 text-orange-700 border-orange-200"],
    documents_required: ["Documents Required", "bg-orange-50 text-orange-700 border-orange-200"],
    submitted: ["Submitted", "bg-blue-50 text-blue-700 border-blue-200"],
    pending: ["Pending Review", "bg-slate-50 text-slate-600 border-slate-200"],
    draft: ["Not Submitted", "bg-slate-50 text-slate-500 border-slate-200"],
    rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200"],
  },
  approval: {
    approved: ["Approved", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    pending: ["Pending", "bg-slate-50 text-slate-600 border-slate-200"],
    rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200"],
  },
  account: {
    active: ["Active", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    suspended: ["Suspended", "bg-rose-50 text-rose-700 border-rose-200"],
    disabled: ["Disabled", "bg-slate-100 text-slate-500 border-slate-200"],
  },
  checklist: {
    verified: ["Verified", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    pending_review: ["Pending Review", "bg-amber-50 text-amber-700 border-amber-200"],
    missing: ["Missing", "bg-rose-50 text-rose-700 border-rose-200"],
    rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200"],
    expired: ["Expired", "bg-orange-50 text-orange-700 border-orange-200"],
    not_applicable: ["Not Applicable", "bg-slate-50 text-slate-400 border-slate-200"],
  },
  document: {
    verified: ["Verified", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    pending: ["Pending Verification", "bg-amber-50 text-amber-700 border-amber-200"],
    rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200"],
    replacement_requested: ["Replacement Requested", "bg-orange-50 text-orange-700 border-orange-200"],
    expired: ["Expired", "bg-orange-50 text-orange-700 border-orange-200"],
  },
};

function Badge({ kind, status }) {
  const [label, cls] = (MAP[kind] || {})[status] || [String(status || "—").replace(/_/g, " "), "bg-slate-50 text-slate-600 border-slate-200"];
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize ${cls}`} data-testid={`badge-${kind}-${status}`}>{label}</span>;
}

export const VerificationBadge = ({ status }) => <Badge kind="verification" status={status} />;
export const ApprovalBadge = ({ status }) => <Badge kind="approval" status={status} />;
export const AccountBadge = ({ status }) => <Badge kind="account" status={status} />;
export const ChecklistBadge = ({ status }) => <Badge kind="checklist" status={status} />;
export const DocumentBadge = ({ status }) => <Badge kind="document" status={status} />;
